import React from 'react';

import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import Card from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CardContent from '@mui/material/CardContent';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import swal from 'sweetalert';
import Allergen from './Allergen';

import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import KImagesTable from './KImagesTable';
import KSubCategoriesTable from './KSubCategoriesTable';
import KProductsTable from './KProductsTable';
import TextField from '@mui/material/TextField';
import DropDown from './DropDown';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import noImage from './../images/noImage.png';
import idle from './../images/icons/idle_on.png';
import registered from './../images/icons/registered_on.png';
import active from './../images/icons/active_on.png';
import discontinued from './../images/icons/discontinued_on.png';

import isDeliverable_off from './../images/icons/isDeliverable_off.png';
import isDeliverable_on from './../images/icons/isDeliverable_on.png';
import isDiscountable_off from './../images/icons/isDiscountable_off.png';
import isDiscountable_on from './../images/icons/isDiscountable_on.png';
import isForSale_off from './../images/icons/isForSale_off.png';
import isForSale_on from './../images/icons/isForSale_on.png';
import isNew_off from './../images/icons/isNew_off.png';
import isNew_on from './../images/icons/isNew_on.png';
import isSellable_off from './../images/icons/isSellable_off.png';
import isSellable_on from './../images/icons/isSellable_on.png';
import canGenerateFidelityPoints_off from './../images/icons/canGenerateFidelityPoints_off.png';
import canGenerateFidelityPoints_on from './../images/icons/canGenerateFidelityPoints_on.png';
import Tooltip from "@mui/material/Tooltip";

import PermMediaIcon from '@mui/icons-material/PermMedia';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import CategoryIcon from '@mui/icons-material/Category';
import TranslateIcon from '@mui/icons-material/Translate';
import Autocomplete from '@mui/material/Autocomplete';

import BackOfficeConfig from './../Config';
import Client from './Client';
import Config from './ClientConfig';

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));



class Combo extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      client: new Client ( "none" ),
      isSelfNew: !(props.combo && props.combo.iref),
      hideMe: false,
      combo: {
        iref: "",
        name: "",
        shortName: "",
        sku: "",
        ean: "",
        pClass: {},
        pCategory: {},
        pSubCategory: {},
        product: [],
        createdOn: "",
        modifiedOn: "",
        description: "",
        isDiscountable: false,
        isDeliverable: false,
        isSellable: false,
        isForSale: false,
        isNew: false,
        status: 0,
      },
      expanded: false,
      // edit: false,
      edit: !(props.combo && props.combo.iref),
      allowEdit: false,
      saveButtonVisible: false,
      //combo_mainImage: null,
      name_valid: false,
      shortName_valid: true,
      description_valid: false,
      ean_valid: false,
      sku_valid: false,
      class_valid: false,
      category_valid: false,
      subcategory_valid: false,
      classes: [],
      aclasses: [],
      categories: [],
      subCategories: [],
      acategories: [],
      asubCategories: [],
      detailsVisible: false,
      tabValue: "images",
      tabsReloadKey: 0,
      translations: [],
      languages: [],
      langById: {},
      languagesReady: false,
      isSavingTr: false,
      trEdit: {}, 
    };

    this.handleExpandClick = this.handleExpandClick.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.getElementByName = this.getElementByName.bind(this);
    this.changeValue = this.changeValue.bind(this);
    this.getClasses = this.getClasses.bind(this);
    this.getCategories = this.getCategories.bind(this);
    this.getSubCategories = this.getSubCategories.bind(this);
    this.changeCategory = this.changeCategory.bind(this);
    this.changeSubCategory = this.changeSubCategory.bind(this);
    this.changeClass = this.changeClass.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
    this.flagOption = this.flagOption.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.pushData = this.pushData.bind(this);
    this.imageUpdated = this.imageUpdated.bind(this);
    this.productUpdated = this.productUpdated.bind(this);
    this.subCategoryUpdated = this.subCategoryUpdated.bind(this);
    this.onTrFieldChange = this.onTrFieldChange.bind(this);
    this.saveTranslation = this.saveTranslation.bind(this);
    this.addBlankTranslation = this.addBlankTranslation.bind(this);
    this.toggleTrEdit = this.toggleTrEdit.bind(this);
  }

  componentDidMount ( ) {
    if (this.props.combo) {
      const cmb = this.props.combo;
      this.setState({ combo: cmb, detailsVisible: true });
      if (cmb.name?.length > 0) this.setState({ name_valid: true });
      if ((cmb.shortName ?? "").length > 0 && (cmb.shortName ?? "").length <= 16) this.setState({ shortName_valid: true });
      if (cmb.description?.length > 0) this.setState({ description_valid: true });
      if (cmb.ean?.length > 0) this.setState({ ean_valid: true });
      if (cmb.sku?.length > 0) this.setState({ sku_valid: true });
      if (cmb.pClass !== undefined) this.setState({ class_valid: true });
      if (cmb.pCategory !== undefined) this.setState({ category_valid: true });
      if (cmb.pSubCategory !== undefined) this.setState({ subcategory_valid: true });
    }

    if (this.props.allowEdit === true) this.setState({ allowEdit: true });

    if (this.props.allergensList) this.setState({ allergensList: this.props.allergensList });

    if (this.state.edit) {
      this.setState({ expanded: true, detailsVisible: true });
      this.getClasses();
      this.getCategories();
      this.getSubCategories(this.state.combo?.pCategory?.iref);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props !== prevProps) {
      if (this.props.combo) {
        const cmb = this.props.combo;
        this.setState({ combo: cmb, detailsVisible: true });

        if (cmb.name?.length > 0) this.setState({ name_valid: true });
        if ((cmb.shortName ?? "").length > 0 && (cmb.shortName ?? "").length <= 16) this.setState({ shortName_valid: true });
        if (cmb.description?.length > 0) this.setState({ description_valid: true });
        if (cmb.ean?.length > 0) this.setState({ ean_valid: true });
        if (cmb.sku?.length > 0) this.setState({ sku_valid: true });
        if (cmb.pClass !== undefined) this.setState({ class_valid: true });
        if (cmb.pCategory !== undefined) this.setState({ category_valid: true });
        if (cmb.pSubCategory !== undefined) this.setState({ subcategory_valid: true });
      }

      if (this.props.allergensList)
        this.setState({ allergensList: this.props.allergensList });
    }
    if (!prevState.edit && this.state.edit) {
      this.getClasses();
      this.getCategories();
      this.getSubCategories(this.state.combo?.pCategory?.iref);
    }
    const prevHadCombo = !!prevProps.combo;
    const nowNewCombo = this.props.combo && !this.props.combo.iref;
    if ((!prevHadCombo && nowNewCombo) || (prevProps.combo?.iref && !this.props.combo?.iref)) {
      if (this.state.edit) this.getClasses();
    }
  }

  handleExpandClick ( ) {
    this.setState({ expanded: !this.state.expanded });
  }

  handleEditClick() {
    if (!this.state.allowEdit) return;
    this.setState(
      prev => ({ edit: !prev.edit, expanded: true, saveButtonVisible: !prev.edit }),
      () => { if (this.state.edit) this.setState(p => ({ tabsReloadKey: p.tabsReloadKey + 1 })); }
    );
    this.getClasses();
    this.getCategories();
    this.getSubCategories(this.state.combo?.pCategory?.iref);
  }

  handleTabChange = (e, newValue) => {
    this.setState({ tabValue: newValue }, async () => {
      if (newValue === "products" && this.state.edit) {
        this.setState(p => ({ tabsReloadKey: p.tabsReloadKey + 1 }));
      }
      if (newValue === "images") {
        if (!this._imagesNode) this.buildImagesNode();
      }
      if (newValue === "translations") {
        await this.loadLanguages();
        if (this.state.combo?.iref) await this.loadTranslations();
      }
    });
  }

  reloadComboAndTabs = () => {
    const queryData = { iref: this.state.combo.iref /* add flags if your API needs details */ };
    const rdata = this.state.client.getData(Config.API_URL_COMBO + this.state.combo.iref, queryData);
    if (rdata) {
      this.setState({ combo: rdata }, () => {
        // only now remount tab contents so they see populated props
        this.setState(prev => ({ tabsReloadKey: prev.tabsReloadKey + 1 }));
      });
    }
  };

  getElementByName ( elements, name ) {    
    let e = {
      "iref" : null,
      "name" : "X",
      "image" : "X",
      "image_off" : "X"
    };
    if ( elements !== null && elements !== undefined ) {
      for ( var i = 0; i < elements.length; i++ ) {
        let el = elements[ i ];
        if ( el.length === 2 ) {
          if ( el[ 1 ].name === name ) e = el[ 1 ];
        } else {
          if ( el[ 0 ].name === name ) e = el[ 0 ];
        }        
      }
    }
    return e;    
  }

  changeStatus ( e ) {
    let uCombo = this.state.combo;
    uCombo.status = parseInt ( e );
    this.setState ( { combo: uCombo } );
    this.setState ( { somethingHasChanged: true } );
  }

  getClasses ( ) {
    if (this.state._classesLoading) return;
    this.setState({ _classesLoading: true });
    let data = this.state.client.getProductsClasses ( );
    if ( data ) {
      let classes = {};
      for ( var i = 0; i < data.productClasses.length; i++ ) {
        classes[ data.productClasses[ i ].iref ] = {          
          "name": data.productClasses[ i ].name,
          "image": data.productClasses[ i ].image
          }
      }
      this.setState ( { classes: classes } );
      this.setState ( { aclasses: data.productClasses } );
    }
    this.setState({ _classesLoading: false });
  }

  changeClass(e) {
    let classSet = false;
    let uCombo = this.state.combo;
    for (let i = 0; i < this.state.aclasses.length; i++) {
      if (this.state.aclasses[i].iref === e) {
        uCombo.pClass = this.state.aclasses[i];
        classSet = true;
      }
    }
    this.setState({ combo: uCombo, class_valid: !!classSet, somethingHasChanged: true }, () => {
      if (this.state.edit && this.state.tabValue === "products") {
        this.setState(p => ({ tabsReloadKey: p.tabsReloadKey + 1 }));
      }
    });
  }

  getCategories() {
    const data = this.state.client.getProductsCategories();
    if (data) {
      const categories = {};
      for (let i = 0; i < data.productCategories.length; i++) {
        categories[data.productCategories[i].iref] = {
          name: data.productCategories[i].name,
          image: data.productCategories[i].image,
        };
      }
      this.setState({ categories, acategories: data.productCategories });
    }
  }

  getSubCategories(category) {
    const queryData = { category };
    const data = this.state.client.getProductsSubCategories(queryData);
    if (data) {
      const subCategories = {};
      for (let i = 0; i < data.productSubCategories.length; i++) {
        subCategories[data.productSubCategories[i].iref] = {
          name: data.productSubCategories[i].name,
          image: data.productSubCategories[i].image,
        };
      }
      this.setState({ subCategories, asubCategories: data.productSubCategories });
    }
  }

  changeCategory(e) {
    let categorySet = false;
    const uCombo = { ...this.state.combo };
    for (let i = 0; i < this.state.acategories.length; i++) {
      if (this.state.acategories[i].iref === e) {
        uCombo.pCategory = this.state.acategories[i];
        categorySet = true;
      }
    }
    // When category changes, refresh subcategories
    this.setState(
      { combo: uCombo, category_valid: !!categorySet, somethingHasChanged: true },
      () => this.getSubCategories(e)
    );
  }

  changeSubCategory(e) {
    let subCategorySet = false;
    const uCombo = { ...this.state.combo };
    for (let i = 0; i < this.state.asubCategories.length; i++) {
      if (this.state.asubCategories[i].iref === e) {
        uCombo.pSubCategory = this.state.asubCategories[i];
        subCategorySet = true;
      }
    }
    this.setState({
      combo: uCombo,
      subcategory_valid: !!subCategorySet,
      somethingHasChanged: true,
    });
  }

  changeValue ( e ) {
    let id = null;
    if ( e.target.id !== null ) id = e.target.id;
    let value = null;
    if  ( e.target.value !== null ) value = e.target.value;
    if ( id !== null) {
      let uCombo = this.state.combo;
      switch ( id ) {
        case "name":
          uCombo.name = value;
          if ( value.length > 2 ) this.setState ( { name_valid: true } );
          else this.setState ( { name_valid: false } );
          break;
        case "shortName":
          uCombo.shortName = value;
          // valid if empty OR ≤ 16 chars (model: blank=True, null=True, max_length=16)
          this.setState({ shortName_valid: value.length > 0 && value.length <= 16 });
          break;
        case "description":
          uCombo.description = value;
          if ( value.length > 2 ) this.setState ( { description_valid: true } );
          else this.setState ( { description_valid: false } );
          break;
        case "ean":
          uCombo.ean = value;
          if ( value.length > 0 ) this.setState ( { ean_valid: true } );
          else this.setState ( { ean_valid: false } );
          break;
        case "sku":
          uCombo.sku = value;
          if ( value.length > 0 ) this.setState ( { sku_valid: true } );
          else this.setState ( { sku_valid: false } );
          break;
        default:
          console.warn(`Unhandled id: ${id}`);
          break;
      }

      this.setState ( { combo: uCombo } );
      this.setState ( { somethingHasChanged: true } );
    }
  }

  flagOption ( e ) {
    let option = e.target.alt;
    let uCombo = this.state.combo;
    uCombo[ option ] = !uCombo[ option ];
    this.setState ( { combo: uCombo } );
    this.setState ( { somethingHasChanged: true } );
  }

  pushData(e) {
    // Allow save only when in edit and validations passed
    if (
      this.state.edit &&
      this.state.somethingHasChanged &&
      this.state.name_valid &&
      this.state.description_valid &&
      this.state.sku_valid &&
      this.state.class_valid &&
      this.state.category_valid &&
      this.state.subcategory_valid
    ) {

      // Prepare payload
      let uCombo = { ...this.state.combo };

      // Flatten allergens to iref list expected by backend
      const allergensNew = [];
      if (uCombo.allergens) {
        for (let i = 0; i < uCombo.allergens.length; i++) {
          let iref = null;
          if (uCombo.allergens[i]?.iref) iref = uCombo.allergens[i].iref;
          else iref = uCombo.allergens[i];
          if (iref) allergensNew.push(iref);
        }
      }
      uCombo["allergensNew"] = allergensNew;

      // Backend-owned fields should not be posted back
      uCombo.modifiedOn = "";
      uCombo.createdOn = "";

      // Save
      const rdata = this.state.client.pushData(Config.API_URL_COMBO_ADD, uCombo);
      if (rdata) {
        if (rdata.status === "OK") {
          // Ensure we have iref locally
          const nextCombo = { ...this.state.combo, iref: rdata.iref };
          const isNewCard = (this.state.isSelfNew || this.props.isNew === true);

          this.setState(
            {
              combo: nextCombo,
              // ⬇️ leave edit mode after a successful save (create or update)
              edit: false,
              expanded: true,          // keep details open
              detailsVisible: true,    // ensure tabs are visible
              saveButtonVisible: false,
              somethingHasChanged: false,
              errorMessage: null,
              hideMe: isNewCard, // ⬅️ hide this “new” placeholder once it has an iref
            },
            () => {
              if (!isNewCard) {
                // Only reload tabs if this is an existing card being updated.
                this.reloadComboAndTabs();
              }
              if (this.props.comboUpdated) this.props.comboUpdated();
            }
          );

          swal(
            "Success",
            "Successfully added/modified combo ! (" + rdata.iref + ")",
            "success",
            { buttons: false, timer: 2000 }
          );
        } else {
          if (rdata.message) this.setState({ errorMessage: rdata.message });
          swal("Add/Update combo failed !", rdata.message || "", "error");
        }
      }
    } else {
      swal("Error", "Add/Update combo failed !", "error");
    }
  }

  _imagesNode = null;
  _imagesSourceRef = null;

  buildImagesNode = () => {
    const combo = this.state.combo || {};
    const images = combo.comboImage_productCombo || [];
    this._imagesSourceRef = images; // keep the array reference we used
    this._imagesNode = (
      <KImagesTable
        key={`images:${combo.iref || 'new'}:${this.state.tabsReloadKey}`}
        images={images}
        edit={this.state.edit}
        viewDetails={this.state.viewDetails}
        saveURL={Config.API_URL_COMBO_ADD_IMAGE}
        removeURL={Config.API_URL_COMBO_REMOVE_IMAGE}
        parentIref={combo.iref}
        imageUpdated={this.imageUpdated}
      />
    );
  };

  imageUpdated ( ) {
    let queryData = {
      iref: this.state.combo.iref
    }
    let rdata = this.state.client.getData ( Config.API_URL_COMBO + this.state.combo.iref, queryData );
    if ( rdata ) {
      this.setState({ combo: rdata }, () => {
        // rebuild cached images node since the source changed
        this.buildImagesNode();
      });
      /* if ( rdata.comboImage_productCombo ) {
        let uCombo = this.state.combo;
        uCombo.comboImage_productCombo = rdata.comboImage_productCombo;
        this.setState ( { combo: uCombo } );
      } */
    }
  }

  productUpdated ( ) {
    let queryData = {
      iref: this.state.combo.iref
    }
    let rdata = this.state.client.getData ( Config.API_URL_COMBO + this.state.combo.iref, queryData );
    if ( rdata ) {
      this.setState ( { combo: rdata } );
    }
  }

  subCategoryUpdated ( ) {
    let queryData = {
      iref: this.state.combo.iref
    }
    let rdata = this.state.client.getData ( Config.API_URL_COMBO + this.state.combo.iref, queryData );
    if ( rdata ) {
      this.setState ( { combo: rdata } );
    }
  }

  async loadLanguages() {
    if (this._LANGS_CACHE && this._LANGS_BY_ID) {
      this.setState({ languages: this._LANGS_CACHE, langById: this._LANGS_BY_ID, languagesReady: true });
      return;
    }
    if (this._LANGS_LOADING) {
      await this._LANGS_LOADING;
      this.setState({ languages: this._LANGS_CACHE || [], langById: this._LANGS_BY_ID || {}, languagesReady: true });
      return;
    }
    this._LANGS_LOADING = (async () => {
      const base = (this.props.API_URL_LANGUAGE || Config.API_URL_LANGUAGE || '/api/1.0/languages/').replace(/^https?:\/\/[^/]+/i,'');
      const data = this.state.client.getData(base, {});
      const raw = Array.isArray(data?.Languages) ? data.Languages : [];
      const list = raw.map(x => ({ iref: String(x.iref), languageName: String(x.languageName || '').trim() }))
                      .filter(x => x.iref && x.languageName);
      const map = {}; list.forEach(l => { map[l.iref] = l; });
      this._LANGS_CACHE = list; this._LANGS_BY_ID = map;
    })();
    try { await this._LANGS_LOADING; } finally { this._LANGS_LOADING = null; }
    this.setState({ languages: this._LANGS_CACHE, langById: this._LANGS_BY_ID, languagesReady: true });
  }

  toRelative = (u) => (!u ? '' : String(u).replace(/^https?:\/\/[^/]+/i, ''));
  joinUrl = (base, path) => {
    const b = (base || '').endsWith('/') ? base : (base + '/');
    const p = (path || '').startsWith('/') ? path.slice(1) : path;
    return b + p;
  };

  async loadTranslations() {
    const id = this.state.combo?.iref; if (!id) return;
    const base = this.toRelative(this.props.API_URL_COMBO || Config.API_URL_COMBO || '/api/1.0/combos/');
    const url  = this.joinUrl(base, `${id}/translations/`);
    const data = this.state.client.getData(url, {});
    if (!data) { swal('Error','Could not load translations','error'); return; }

    const rows = Array.isArray(data?.translations) ? data.translations : [];
    const normalized = rows.map(r => {
      const langId = (r.language && typeof r.language === 'object')
        ? String(r.language.iref)
        : (r.language != null ? String(r.language) : null);
      return { ...r, language: langId };
    });
    this.setState({ translations: normalized });
  }

  onTrFieldChange = (iref, field, value) => {
    this.setState(s => ({
      translations: (s.translations || []).map(r => String(r.iref) === String(iref) ? { ...r, [field]: value } : r)
    }));
  };

  toggleTrEdit(iref, force) {
    this.setState(s => ({ trEdit: { ...s.trEdit, [iref]: (typeof force === 'boolean' ? force : !s.trEdit[iref]) } }));
  }

  saveTranslation = async (row) => {
    const comboId = this.state.combo?.iref;
    if (!comboId) { swal('Error','Save the combo first, then add translations.','error'); return; }
    this.setState({ isSavingTr: true });

    const isRealId = row.iref && Number(row.iref) > 0;
    const payload = {
      ...(isRealId ? { iref: row.iref } : {}),
      language_iref: row.language || null,
      name: (row.name ?? '').trim(),
      description: (row.description ?? '').trim(),
      shortName: (row.shortName ?? '').trim()
    };

    try {
      const base = this.toRelative(this.props.API_URL_COMBO || Config.API_URL_COMBO || '/api/1.0/combos/');
      const url  = this.joinUrl(base, `${comboId}/translations_save/`);
      const data = this.state.client.pushData(url, payload);

      if (data && data.status === 'OK') {
        const saved  = data.row;
        const langId = saved?.language && typeof saved.language === 'object'
          ? String(saved.language.iref) : String(saved.language || '');
        const merged = { ...saved, language: langId || null };
        this.setState(s => {
          const list = [...s.translations];
          const idx = list.findIndex(x => x.iref === row.iref || x.iref === merged.iref);
          if (idx >= 0) list[idx] = merged; else list.unshift(merged);
          return { translations: list, isSavingTr: false, trEdit: { ...s.trEdit, [merged.iref]: false } };
        });
        swal('Saved','Translation saved.','success',{ buttons:false, timer:900 });
      } else {
        const msg = (data && (data.message || JSON.stringify(data.errors))) || 'Unknown error';
        swal('Save failed', msg, 'error'); this.setState({ isSavingTr: false });
      }
    } catch (e) {
      swal('Save failed', e.message || String(e), 'error');
      this.setState({ isSavingTr: false });
    }
  };

  hasOpenDraft = () => (this.state.translations || []).some(t => Number(t.iref) < 0);

  addBlankTranslation = () => {
    if (this.hasOpenDraft()) {
      swal('Heads up', 'Please finish or cancel the current draft translation first.', 'info');
      return;
    }
    const tmpId = -Date.now();
    const newRow = {
      iref: tmpId,
      productCombo: this.state.combo?.iref,
      language: null,
      name: '',
      description: '',
      shortName: ''
    };
    this.setState(s => ({
      translations: [newRow, ...s.translations],
      trEdit: { ...s.trEdit, [tmpId]: true }
    }));
  };

  render() {
    if (this.state.hideMe) return null;
    // If this card started life without an iref (self new) OR was explicitly flagged as new,
    // hide it once an iref exists to avoid duplicate with the parent's “real” card.
    if ((this.state.isSelfNew || this.props.isNew === true) && this.state.combo?.iref) {
      return null;
    }
    let combo_name = "";
    let combo_shortName = "";
    let combo_description = "";
    let combo_image = noImage;
    let combo_ean = "";
    let combo_sku = "";
    let combo_modifiedOn = "";
    let combo_class_name = "";
    let combo_class_image = noImage;
    let combo_status = 0;
    let combo_status_image = noImage;
    let combo_status_alt = "Unknown"
    let combo_class_iref = "";
    let combo_Category_iref = "";
    let combo_Category_name = "";
    let combo_Category_image = noImage;
    let combo_SubCategory_iref = "";
    let combo_SubCategory_name = "";
    let combo_SubCategory_image = noImage;
    let isDeliverable = isDeliverable_off;
    let isDiscountable = isDiscountable_off;
    let isForSale = isForSale_off;
    let isNew = isNew_off;
    let isSellable = isSellable_off;
    let canGenerateFidelityPoints = canGenerateFidelityPoints_off;

    let comboImages = [];
    let comboSubCategories = [];
    let comboProducts = [];

    if ( this.state.combo ) {
      let combo = this.state.combo;
      if ( combo.status ) combo_status = combo.status;    
      if ( combo.name ) combo_name = combo.name;
      if (combo.shortName) combo_shortName = combo.shortName;
      if ( combo.description ) combo_description = combo.description;
      if ( combo.modifiedOn ) combo_modifiedOn = combo.modifiedOn;
      if ( combo.ean ) combo_ean = combo.ean;
      if ( combo.sku ) combo_sku = combo.sku;

      if ( combo.pClass ) {
        combo_class_iref = combo.pClass.iref;
        if( combo.pClass.name && combo.pClass.name !== "null" )
          combo_class_name = "Product Class: " + combo.pClass.name;
        if( combo.pClass.image && combo.pClass.image !== "null" && !combo.pClass.image.startsWith("data:") ) {
          combo_class_image = combo.pClass.image;        
          let fileName = combo_class_image.replace(/\.[^/.]+$/, "")
          let fileExtensions = combo_class_image.split(".").pop();
          combo_class_image = fileName + "_s." + fileExtensions;
        }
      }
      if (combo.pCategory) {
        combo_Category_iref = combo.pCategory.iref;
        if (combo.pCategory.name && combo.pCategory.name !== "null")
          combo_Category_name = "Product Category: " + combo.pCategory.name;
        if (combo.pCategory.image && combo.pCategory.image !== "null" && !combo.pCategory.image.startsWith("data:")) {
          combo_Category_image = combo.pCategory.image;
          const fileName = combo_Category_image.replace(/\.[^/.]+$/, "");
          const fileExt = combo_Category_image.split(".").pop();
          combo_Category_image = fileName + "_s." + fileExt;
        }
      }
      if (combo.pSubCategory) {
        combo_SubCategory_iref = combo.pSubCategory.iref;
        if (combo.pSubCategory.name && combo.pSubCategory.name !== "null")
          combo_SubCategory_name = "Product Subcategory: " + combo.pSubCategory.name;
        if (combo.pSubCategory.image && combo.pSubCategory.image !== "null" && !combo.pSubCategory.image.startsWith("data:")) {
          combo_SubCategory_image = combo.pSubCategory.image;
          const fileName = combo_SubCategory_image.replace(/\.[^/.]+$/, "");
          const fileExt = combo_SubCategory_image.split(".").pop();
          combo_SubCategory_image = fileName + "_s." + fileExt;
        }
      }

      switch ( combo.status ) {
        case 0:
          combo_status_image = registered;
          combo_status_alt = "Registered";
          break;
        case 1:
          combo_status_image = idle;
          combo_status_alt = "Idle";
          break;
        case 2:
          combo_status_image = active;
          combo_status_alt = "Active";
          break;
        case 9:
          combo_status_image = discontinued;
          combo_status_alt = "Discontinued";
          break;
        default:
          combo_status_image = discontinued;
          combo_status_alt = "Unknown status";
          console.warn(`Unhandled combo status: ${combo.status}`);
          break;
      }

      if ( combo.isDeliverable === true ) isDeliverable = isDeliverable_on;
      if ( combo.isDiscountable === true ) isDiscountable = isDiscountable_on;
      if ( combo.isForSale === true ) isForSale = isForSale_on;
      if ( combo.isNew === true ) isNew = isNew_on;
      if ( combo.isSellable === true ) isSellable = isSellable_on;
      if ( combo.canGenerateFidelityPoints === true ) canGenerateFidelityPoints = canGenerateFidelityPoints_on;

      let comboHasImage = false;
      const imgs = Array.isArray(combo.comboImage_productCombo) ? combo.comboImage_productCombo : [];
      // prefer main image that is a real string
      const main = imgs.find(x => x?.isMain === true && typeof x?.image === "string" && x.image.trim());
      // fallback to any valid image
      const any  = imgs.find(x => typeof x?.image === "string" && x.image.trim());
      if (main || any) {
        comboHasImage = true;
        combo_image = (main?.image || any?.image);
      } else {
        comboHasImage = false;
        combo_image = noImage; // keep it safe
      }

      /* comboImages = <KImagesTable
                      key={`images:${this.state.combo?.iref || 'new'}:${this.state.tabsReloadKey}`}
                      images = {combo.comboImage_productCombo}
                      edit = {this.state.edit}
                      viewDetails = {this.state.viewDetails}
                      saveURL = {Config.API_URL_COMBO_ADD_IMAGE}
                      removeURL = {Config.API_URL_COMBO_REMOVE_IMAGE}
                      parentIref = {combo.iref}
                      imageUpdated = {this.imageUpdated}
                    />; */

      // Only (re)build if images ref changed or cache is empty
      if (!this._imagesNode || this._imagesSourceRef !== (combo.comboImage_productCombo || [])) {
        this.buildImagesNode();
      }
      comboImages = this._imagesNode;

      comboSubCategories = <KSubCategoriesTable
                            key={`subcats:${this.state.combo?.iref || 'new'}:${this.state.tabsReloadKey}`}
                            subCategories = {combo.comboCategory_productCombo}
                            edit = {this.state.edit}
                            viewDetails = {this.state.viewDetails}
                            saveURL = {Config.API_URL_COMBO_ADD_SUBCATEGORY_TO_COMBO}
                            removeURL = {Config.API_URL_COMBO_REMOVE_SUBCATEGORY_FROM_COMBO}
                            parentIref = {combo.iref}
                            subCategoryUpdated = {this.subCategoryUpdated}
                          />;


      if (
        comboHasImage &&
        typeof combo_image === "string" &&
        !combo_image.startsWith("data:") &&
        combo_image.includes(".")
      ) {
        const fileName = combo_image.replace(/\.[^/.]+$/, "");
        const ext = combo_image.split(".").pop();
        combo_image = `${fileName}_s.${ext}`;
      } else {
        comboHasImage = false;
        combo_image = noImage;
      }
      //console.log ( combo_image );

      const rawProducts = combo.combo_productComboProduct || [];
      const productsPatched = rawProducts.map((pc, idx) => {
        const cloned = { ...pc, product: { ...(pc.product || {}) } };
        // Ensure a stable key for KProductsTable's <TableRow key={product.iref}>
        if (!cloned.product.iref) {
          cloned.product.iref = cloned.iref || `tmp-${combo.iref || 'new'}-${idx}`;
        }
        return cloned;
      });

      comboProducts = <KProductsTable
                        key={`products:${this.state.combo?.iref || 'new'}:${this.state.tabsReloadKey}`}
                        products = {combo.combo_productComboProduct}
                        edit = {this.state.edit}
                        viewDetails = {this.state.viewDetails}
                        saveURL = {Config.API_URL_COMBO_ADD_PRODUCT_TO_COMBO}
                        removeURL = {Config.API_URL_COMBO_REMOVE_PRODUCT_FROM_COMBO}
                        parentIref = {combo.iref}
                        productUpdated = {this.productUpdated}
                      />;
    }
    
    let allergens;
    let allergensRender = "";

    if ( this.props.allergensList ) {
      let allergensArr = Object.entries ( this.props.allergensList );      
      allergensRender = allergensArr.map ( (allergen) => {
        let img_on = "";
        let img_off = "";
        let name = "";
        let img = "";
        let iref = "";
        if ( allergen.length === 2 ) {          
          iref = allergen[ 1 ].iref;
          name = allergen[ 1 ].name;
          img_on = allergen[ 1 ].image;
          img_off = allergen[ 1 ].image_off;
        } else {
          iref = allergen[ 0 ].iref;
          name = allergen[ 0 ].name;
          img_on = allergen[ 0 ].image;
          img_off = allergen[ 0 ].image_off;
        }
        img = img_off;
        if ( this.state.combo.allergens ) {
          allergens = this.state.combo.allergens.map ( (allergen) => {
            if ( allergen === iref ) img = img_on;
          });
        }
      return <Allergen
        key = {name}
        name = {name}
        image = {img}
        />
      });
    }

    let tabValue = "images";
    if ( this.state.tabValue ) tabValue = this.state.tabValue;

    let saveButtonVisible = false;
    if ( this.state.edit && this.state.somethingHasChanged && 
        this.state.name_valid && this.state.description_valid &&
        this.state.sku_valid && this.state.shortName_valid && this.state.class_valid &&
        this.state.category_valid && this.state.subcategory_valid )
        saveButtonVisible = true;

    return (
      /* , display: 'flex' */
    <Card sx={{ borderRadius: '16px', m: 1 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <CardHeader
          avatar={          
            <Box sx={{ display: 'flex', flexDirection: 'row', width: "100%" }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', width: "100%" }}>      
                <Avatar alt={combo_status_alt} src={combo_status_image} title={combo_status_alt}>
                </Avatar>  
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', width: "100%" }}>
                <Typography variant="subtitle1" color="text.secondary">
                  {this.state.combo.iref}
                </Typography>
              </Box>
            </Box> 
          }        
          action={            
            <IconButton aria-label="settings" onClick={this.handleEditClick}>
              <EditIcon
                sx={{ color: this.state.edit ? "#8f241d" : "#e3e3e5" }}
              />
            </IconButton>
          }
          title={combo_name}
          subheader=""
          titleTypographyProps={{variant:'h5' }}
        />

        <Box sx={{ display: 'flex', flexDirection: 'row' }}>

        <CardMedia
          component="img"
          height="120"
          sx={{ width: 128, marginLeft: 1 }}
          image={combo_image}
          alt={combo_name}
        />

      {this.state.edit ?
        <Box sx={{ flexDirection: 'column', display: "block", width: "30%", marginLeft: 1, marginBottom: 1 }}>
          <DropDown
            name="Status"
            size="small"
            value={combo_status !== undefined ? combo_status : ''}
            doptions={BackOfficeConfig.PRODUCT_STATUSES_WITH_ICONS}
            hasIcons={true}   
            minWidth={220}
            maxWidth={220}
            onDark={false}
            onChangeFunction={this.changeStatus}
            marginTop={8}
            marginLeft={0}
            margin={0}
          />
          <DropDown
            name="Class"
            size="small"
            value={combo_class_iref !== undefined ? combo_class_iref : ''}
            doptions={this.state.classes}
            hasIcons={true}   
            minWidth={220}
            maxWidth={220}
            onDark={false}
            onChangeFunction={this.changeClass}
            marginTop={8}
            marginLeft={0}
            margin={0}
            error={this.state.class_valid === false}
          />
          <DropDown
            name="Category"
            size="small"
            value={combo_Category_iref !== undefined ? combo_Category_iref : ''}
            doptions={this.state.categories}
            hasIcons={true}
            minWidth={220}
            maxWidth={220}
            onDark={false}
            onChangeFunction={this.changeCategory}
            marginTop={8}
            marginLeft={0}
            margin={0}
            error={this.state.category_valid === false}
          />
          <DropDown
            name="Sub Category"
            size="small"
            value={combo_SubCategory_iref !== undefined ? combo_SubCategory_iref : ''}
            doptions={this.state.subCategories}
            hasIcons={true}
            minWidth={220}
            maxWidth={220}
            onDark={false}
            onChangeFunction={this.changeSubCategory}
            marginTop={8}
            marginLeft={0}
            margin={0}
            error={this.state.subcategory_valid === false}
          />
          <TextField
            id="ean"
            label="EAN"
            value={combo_ean || ''}
            variant="outlined"
            size="small"
            onChange={this.changeValue}
            sx={{minWidth: "25%", marginTop: 1, marginLeft: 0}}
            onFocus={event => { event.target.select(); }}
            inputProps={{maxLength:"100"}}
          />
          <TextField
            id="sku"
            label="SKU"
            value={combo_sku || ''}
            variant="outlined"
            size="small"
            onChange={this.changeValue}
            sx={{minWidth: "25%", marginTop: 1, marginLeft: 0}}
            onFocus={event => { event.target.select(); }}
            inputProps={{maxLength:"255"}}
            error={this.state.sku_valid === false}
          />
          <TextField
            id="shortName"
            label="Short Name"
            value={combo_shortName || ''}
            variant="outlined"
            size="small" 
            onChange={this.changeValue}
            sx={{minWidth: "25%", marginTop: 1, marginLeft: 0}}
            onFocus={e => { e.target.select(); }}
            inputProps={{maxLength:"16"}}
            error={this.state.shortName_valid === false}
          />
        </Box>
        :
        <Box sx={{ flexDirection: 'column', display: "block" }}>
          <CardContent sx={{textAlign: "left"}}>
            <Typography variant="body2" color="text.secondary">
              {combo_description}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {combo_ean ? "EAN: " + combo_ean : ""}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {combo_sku ? "SKU: " + combo_sku : ""}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {combo_shortName ? "Short: " + combo_shortName : ""}
            </Typography>
          </CardContent>


          <CardActions disableSpacing sx={{display: "flex", justifyContent: "flex-end"}}>
            <IconButton aria-label={combo_class_name} title={combo_class_name}>
              <Avatar alt={combo_class_name} src={combo_class_image} sx={{ width: 48, height: 48 }}/>
            </IconButton>
            <IconButton aria-label={combo_Category_name} title={combo_Category_name}>
              <Avatar alt={combo_Category_name} src={combo_Category_image} sx={{ width: 48, height: 48 }}/>
            </IconButton>
            <IconButton aria-label={combo_SubCategory_name} title={combo_SubCategory_name}>
              <Avatar alt={combo_SubCategory_name} src={combo_SubCategory_image} sx={{ width: 48, height: 48 }}/>
            </IconButton>
          </CardActions>
        </Box>
        }

        <Box sx={{ flexDirection: 'column', justifyContent:"right", width: '100%' }}>

          {this.state.edit ?
            <Box sx={{ display: "flex", flexDirection: 'row', justifyContent:"right", width: '100%' }}>
              <TextField
                id="name"
                //key={combo_name}
                label="Name"
                value={combo_name || ''}
                variant="outlined"
                size="small" 
                onChange={this.changeValue}
                sx={{minWidth: "30%", marginLeft: 2, marginTop: 1}}
                onFocus={event => { event.target.select(); }}
                inputProps={{maxLength:"100"}}
                error={this.state.name_valid === false}                
              />
              <TextField
                id="description"
                //key={combo_description}
                label="Description"
                value={combo_description || ''}
                variant="outlined"
                size="small" 
                onChange={this.changeValue}
                sx={{minWidth: "30%", marginTop: 1, marginLeft: 1, marginRight: 1}}
                onFocus={event => { event.target.select(); }}
                inputProps={{maxLength:"1024"}}
                error={this.state.description_valid === false}
              />
            </Box>
            : ""
          }
        
          <CardActions disableSpacing sx={{display: "block", textAlign: "end"}}>
            {allergensRender}
          </CardActions>
          
          <CardActions disableSpacing sx={{display: "block", textAlign: "end" }}>          
            
            {/* <IconButton aria-label="canGenerateFidelityPoints" title="canGenerateFidelityPoints">
                <Avatar alt="canGenerateFidelityPoints" src={canGenerateFidelityPoints} sx={{ width: 24, height: 24 }}/>
            </IconButton> */}

            <Tooltip title="isDeliverable" arrow disableInteractive>
              <span>  
                <IconButton aria-label="isDeliverable" title="isDeliverable" onClick={this.flagOption} disabled={!this.state.edit}>
                    <Avatar alt="isDeliverable" src={isDeliverable} sx={{ width: 24, height: 24 }}/>
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title="isDiscountable" arrow disableInteractive>
              <span>  
                <IconButton aria-label="isDiscountable" title="isDiscountable" onClick={this.flagOption} disabled={!this.state.edit}>
                    <Avatar alt="isDiscountable" src={isDiscountable} sx={{ width: 24, height: 24 }}/>
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title="isForSale" arrow disableInteractive>
              <span>  
                <IconButton aria-label="isForSale" title="isForSale" onClick={this.flagOption} disabled={!this.state.edit}>
                    <Avatar alt="isForSale" src={isForSale} sx={{ width: 24, height: 24 }}/>
                </IconButton>
              </span>
            </Tooltip> 
            <Tooltip title="isNew" arrow disableInteractive>
              <span>             
                <IconButton aria-label="isNew" title="isNew" onClick={this.flagOption} disabled={!this.state.edit}>
                    <Avatar alt="isNew" src={isNew} sx={{ width: 24, height: 24 }}/>
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title="isSellable" arrow disableInteractive>
              <span>              
                <IconButton aria-label="isSellable" title="isSellable" onClick={this.flagOption} disabled={!this.state.edit}>
                    <Avatar alt="isSellable" src={isSellable} sx={{ width: 24, height: 24 }}/>
                </IconButton>
             </span>
            </Tooltip>
            <Tooltip title="canGenerateFidelityPoint" arrow disableInteractive>
              <span>  
                <IconButton id="canGenerateFidelityPoint" aria-label="canGenerateFidelityPoints" title="canGenerateFidelityPoints" onClick={this.flagOption} disabled={!this.state.edit}>
                    <Avatar alt="canGenerateFidelityPoints" src={canGenerateFidelityPoints} sx={{ width: 24, height: 24 }}/>
                </IconButton>
              </span>
            </Tooltip>

          <Box sx={{ display: 'flex', flexDirection: 'row', textAlign: "middle", justifyContent:"center", alignItems: "center", paddingTop: "8px" }}>
            {this.state.edit && saveButtonVisible ?
              <Button
                variant="contained"
                size="small"
                sx={{ color: "#e3e3e5" }}
                // disabled={!saveButtonVisible}
                startIcon={<SaveIcon />}
                onClick={this.pushData}
              >
                Save
              </Button>
              : combo_modifiedOn ? "Modified on: " + combo_modifiedOn : ""
            }
          </Box>

          
          <ExpandMore
            expand={this.state.expanded}
            onClick={this.handleExpandClick}
            aria-expanded={this.state.expanded}
            aria-label="show more"
          >
            <ExpandMoreIcon />
          </ExpandMore>
        </CardActions>

        </Box>
        </Box>

        <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
          <CardContent sx={{paddingTop: "2px"}}>

            { this.state.detailsVisible ?
            <Box sx={{ width: '100%' }}>
              <Tabs
                value={this.state.tabValue}
                onChange={this.handleTabChange}
                centered
                aria-label="combo tabs"
                indicatorColor="secondary"
              >
                <Tab label="Images" value="images" icon={<PermMediaIcon />} iconPosition="start"/>
                <Tab label="Products" value="products" icon={<FastfoodIcon />} iconPosition="start"/>
                {/* <Tab label="Classes" value="classes" icon={<ClassIcon />} iconPosition="start"/> */}
                <Tab label="Sub Categories" value="subcategories" icon={<CategoryIcon />} iconPosition="start"/>
                <Tab label="Translations" value="translations" icon={<TranslateIcon />} iconPosition="start"/>
              </Tabs>
            </Box>
          : ""
          }

          { this.state.detailsVisible && this.state.combo?.iref && this.state.tabValue === "images" ?
            comboImages
          : ""
          }

          { this.state.detailsVisible && this.state.combo?.iref && this.state.tabValue === "products" ?
            comboProducts
          : ""
          }

          { this.state.detailsVisible && this.state.combo?.iref && this.state.tabValue === "subcategories" ?
            comboSubCategories
          : ""
          }
          {this.state.tabValue === 'translations' && (
            <Box sx={{ p: 1, display:'grid', gridTemplateColumns:'1fr', gap: 1 }}>
              {this.state.allowEdit && this.state.combo?.iref && (
                <Box sx={{ display:'flex', gap: 1, justifyContent:'flex-end' }}>
                  <Button size="small" variant="outlined" onClick={this.addBlankTranslation} disabled={this.hasOpenDraft()}>Add translation</Button>
                </Box>
              )}
              {this.state.translations.length === 0 ? (
                <Typography variant="body2" color="text.secondary">No translations yet.</Typography>
              ) : (
                this.state.translations.map((t) => {
                  const isTemp = (t.iref < 0);
                  return (
                    <Box
                      key={t.iref}
                      sx={{
                        p: 0.5,
                        borderRadius: 1,
                        border: '1px solid #e0e0e0',
                        display: 'grid',
                        gridTemplateColumns: '200px 1fr',
                        gap: 0.5
                      }}
                    >
                      {/* Language column */}
                      <Box sx={{ display: 'grid', gap: 0.5 }}>
                        {(this.state.allowEdit && (this.state.trEdit?.[t.iref] || t.iref < 0)) ? (
                          <Autocomplete
                            options={this.state.languages}
                            size="small"
                            disablePortal
                            getOptionLabel={(opt) => opt?.languageName || ''}
                            isOptionEqualToValue={(opt, val) => opt?.iref === val?.iref}
                            value={(this.state.languagesReady && t.language) ? (this.state.langById[t.language] || null) : null}
                            onChange={(_, val) => this.onTrFieldChange(t.iref, 'language', val ? val.iref : null)}
                            renderInput={(params) => (
                              <TextField {...params} variant="outlined" label="Language" size="small" />
                            )}
                            ListboxProps={{ sx: { maxHeight: 200, p: 0 } }}
                            sx={{ minWidth: 200, mt: 1 }}
                            disabled={!this.state.languagesReady}
                          />
                        ) : (
                          <>
                            <Typography variant="caption" color="text.secondary">Language</Typography>
                            <Typography variant="body2">
                              {!this.state.languagesReady ? '…' : (t.language ? (this.state.langById[t.language]?.languageName || '—') : '—')}
                            </Typography>
                          </>
                        )}
                      </Box>

                      {/* Fields column */}
                      <Box sx={{ display: 'grid', gap: 0.5 }}>
                        {(this.state.allowEdit && (this.state.trEdit?.[t.iref] || t.iref < 0)) ? (
                          <Box
                            sx={{
                              display: 'grid',
                              columnGap: 0.5,
                              rowGap: 0.5,
                              gridTemplateColumns: '1fr 160px auto'
                            }}
                          >
                            {/* Row 1: Title | Short name | Actions */}
                            <TextField
                              size="small" margin="dense" fullWidth
                              label="Title" variant="outlined"
                              value={t.name || ''} inputProps={{ maxLength: 100 }}
                              onChange={(e)=>this.onTrFieldChange(t.iref, 'name', e.target.value)}
                              sx={{ gridColumn: '1 / span 1' }}
                            />
                            <TextField
                              size="small" margin="dense" fullWidth
                              label="Short name" variant="outlined"
                              value={t.shortName || ''} inputProps={{ maxLength: 16 }}
                              onChange={(e)=>this.onTrFieldChange(t.iref, 'shortName', e.target.value)}
                              sx={{ gridColumn: '2 / span 1' }}
                            />
                            <Box sx={{ gridColumn: '3 / span 1', display:'flex', justifyContent:'flex-end', alignItems:'center', gap: 0.5, mt: 1 }}>
                              <Button size="small" variant="contained" disabled={this.state.isSavingTr} onClick={()=>this.saveTranslation(t)}>
                                {this.state.isSavingTr ? 'Saving…' : (isTemp ? 'Add' : 'Save')}
                              </Button>
                              <Button
                                size="small"
                                onClick={()=>{
                                  if (isTemp) {
                                    this.setState(s => ({
                                      translations: (s.translations || []).filter(x => x.iref !== t.iref),
                                      trEdit: { ...s.trEdit, [t.iref]: false }
                                    }));
                                  } else {
                                    this.toggleTrEdit(t.iref, false);
                                  }
                                }}
                              >
                                Cancel
                              </Button>
                            </Box>

                            {/* Row 2: Description (full width) */}
                            <TextField
                              size="small" margin="dense" fullWidth
                              label="Description" variant="outlined"
                              multiline rows={2} inputProps={{ maxLength: 1024 }}
                              value={t.description || ''}
                              onChange={(e)=>this.onTrFieldChange(t.iref, 'description', e.target.value)}
                              sx={{ gridColumn: '1 / span 3' }}
                            />
                          </Box>
                        ) : (
                          <>
                            <Typography variant="subtitle2" sx={{ textAlign: 'left' }}>{t.name || '—'}</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'left' }}>{t.description || '—'}</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'left' }}>Short: {t.shortName || '—'}</Typography>
                            {this.state.allowEdit && (
                              <Box sx={{ display:'flex', justifyContent:'flex-end', mt: 0.5 }}>
                                <Button size="small" onClick={()=>this.toggleTrEdit(t.iref, true)}>Edit</Button>
                              </Box>
                            )}
                          </>
                        )}
                      </Box>
                    </Box>
                  );
                })
              )}
            </Box>
          )}  
          </CardContent>
        </Collapse>
        </Box>
    </Card>
    );
  }
}

export default Combo;